// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "工程力学",
      "tec": "罗旋",
      "week": "1-10周",
      "add": "教学楼D座424能动AISEC"
    },
    [
      {
        "sub": "概率论与数理统计",
        "tec": "杨宇",
        "week": "1-16单周",
        "add": "教学楼D座514能动AISEC"
      },
      {
        "sub": "普通化学（含实验）",
        "tec": "赵海",
        "week": "2,4,6,8,10,12周",
        "add": "教学楼D座514能动AISEC"
      }
    ],
    {
      "sub": "大学英语读写（三）",
      "tec": "林琳",
      "week": "1-12周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "明辨性思维",
      "tec": "魏来",
      "week": "1-16周",
      "add": "教学楼D座424能动AISEC"
    },
    {
      "sub": "工程热力学",
      "tec": "张瑞青",
      "week": "1-14周",
      "add": "教学楼D座514能动AISEC"
    },
    {
      "sub": "物理实验",
      "tec": "孙丽媛",
      "week": "1-12周",
      "add": "教学楼B座215"
    },
    {
      "sub": "工程制图与 CAD",
      "tec": "赵璐",
      "week": "1-10周",
      "add": "教学楼D座424能动AISEC"
    },
    0
  ],
  "3": [
    {
      "sub": "马克思主义基本原理",
      "tec": "王爱华",
      "week": "1-12周",
      "add": "教学楼B座224自控"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "高佳",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男乒",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女排",
        "tec": "李莉",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "搏击",
        "tec": "李罡",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "足球",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男网",
        "tec": "李庆",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "轮滑",
        "tec": "张慧",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "健美操",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "李灏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男乒",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男羽",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "足球"
      }
    ],
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "1-4周",
      "add": "教学楼C座213教务"
    }
  ],
  "4": [
    {
      "sub": "普通化学（含实验）",
      "tec": "赵海",
      "week": "1-14周",
      "add": "教学楼D座514能动AISEC"
    },
    {
      "sub": "大学英语听说（三）",
      "tec": "林琳",
      "week": "1-16周",
      "add": "教学楼D座513能动AISEC"
    },
    {
      "sub": "工程热力学",
      "tec": "张瑞青",
      "week": "1-14周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    {
      "sub": "工程制图与 CAD",
      "tec": "赵璐",
      "week": "1-10周",
      "add": "教学楼D座424能动AISEC"
    }
  ],
  "5": [
    {
      "sub": "马克思主义基本原理",
      "tec": "王爱华",
      "week": "1-12周",
      "add": "教学楼A座422机械"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "杨宇",
      "week": "1-16周",
      "add": "教学楼D座514能动AISEC"
    },
    {
      "sub": "工程力学",
      "tec": "罗旋",
      "week": "1-10周",
      "add": "教学楼D座424能动AISEC"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
